import React from "react";
import "./ContactUs.css";
import { FaPhoneAlt, FaEnvelope, FaWhatsapp } from "react-icons/fa";

const ContactUs = () => {
  return (
    <div className="support-container">
      <div className="support-card">
        <h1>Get in Touch with Us</h1>
        <p className="support-text">
          We'd love to hear from you! Whether you have questions, need assistance, or just want to connect, our team is here for you.
        </p>
        
        <div className="contact-info">
          <div className="contact-item">
            <FaPhoneAlt className="icon" />
            <span>0172-5100108, 98769-80108</span>
          </div>
          <div className="contact-item">
            <FaEnvelope className="icon" />
            <span><a href="mailto:support@altrange.com">support@altrange.com</a>
            </span>
          </div>
        </div>
        
        <div className="contact-buttons">
          <a href="tel:01725100108" className="call-button" target="_blank" rel="noopener noreferrer">Call Now</a>
          <a href="https://wa.me/9876980108" className="whatsapp-button" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp /> WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
